import { FC, useEffect } from 'react';
import { Modal as AntModal, ModalProps as AntModalProps } from 'antd';

export interface ModalProps extends AntModalProps {
  open?: boolean;
}

export const Modal: FC<ModalProps> = ({ open = false, ...props }) => {
  useEffect(() => {
    const originalOverflow = document.body.style.overflow;

    if (open) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = originalOverflow;
    }

    // Возвращаем исходное значение overflow при размонтировании компонента
    return () => {
      if (!open && originalOverflow === 'hidden') {
        document.body.style.overflow = 'auto';
      } else {
        document.body.style.overflow = originalOverflow;
      }
    };
  }, [open]);

  return <AntModal open={open} {...props} />;
};
